import React, { useState, useEffect, useRef } from "react";
import styles from "./Dropdown.module.css";

const Dropdown = (props) => {
  const list = props.props.data;
  const onChange = props.props.onChange;
  const selectRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(list[0]);
  const [showOptions, setShowOptions] = useState(false);

  const handleOnChangeSelectValue = (e) => {
    const value = e.target.getAttribute("value");
    setCurrentValue(value);
    if (onChange) onChange(value);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectRef]);

  return (
    <div
      className={styles.selectBox}
      onClick={() => setShowOptions((prev) => !prev)}
      ref={selectRef}
    >
      <label className={styles.label}>{currentValue}</label>
      <ul className={`${styles.selectOptions} ${showOptions ? styles.show : styles.hide}`}>
        {list.map((data, index) => (
          <li
            key={index}
            className={styles.option}
            value={data}
            onClick={handleOnChangeSelectValue}
          >
            {data}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Dropdown;
